var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.179,
    height: 20,
    viewBox: "0 0 18.179 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-4759929",
    transform: "translate(-262.505 -183.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17276",
    "data-name": "Path 17276",
    d: "M274.958,193.469a5.454,5.454,0,1,0-6.726,0,9.089,9.089,0,0,0-5.726,8.435v.909a.909.909,0,0,0,.909.909h16.361a.909.909,0,0,0,.909-.909V201.9a9.09,9.09,0,0,0-5.726-8.435Zm-7-4.29a3.635,3.635,0,1,1,1.065,2.571A3.637,3.637,0,0,1,267.959,189.179ZM264.323,201.9a7.272,7.272,0,0,1,14.543,0Z",
    fill: "#3b4452"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounUser);
export default __webpack_public_path__ + "static/media/noun_user.2445f38d6800ac31b26344ebce718248.svg";
export { ForwardRef as ReactComponent };